module.exports = "/_next/static/images/16661782e7a0dbf9cf0777b98edbf053-credit-card-prepayment@0.75x.png";